import { DEHUMIDIFIER_OUTWARD_CODES } from "./dehumidifier-coverage-codes.ts"

const dehumidifierDistricts = new Set(DEHUMIDIFIER_OUTWARD_CODES)
export const DELIVERY_CONTACT_REQUIRED = "DELIVERY_CONTACT_REQUIRED"

/** Exact outward-code membership; pricing and other product groups are independent. */
export function instantBookingAreaAllowed(productGroup: string | undefined, outwardCode: string): boolean {
  return productGroup !== "dehumidifier" || dehumidifierDistricts.has(outwardCode.trim().toUpperCase())
}
